import BaseBlockMap from './BaseBlockMap';
import MortgagesBlockMap from './MortgagesBlockMap';


export default {
    ...BaseBlockMap,
    ...MortgagesBlockMap,
};
